<template>
  <div class="" id="Novice">
    <!-- <mt-header fixed title="新手教程">
        <router-link to="/" slot="left">
            <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header> -->
    <!-- <div class="line-59"></div> -->
    <div class="img-box">
      <ul>
        <li>
          <a href="http://web.lianlianche.com/index.html#/video1">
            <div>
              <img src="static/image/video1.png" alt="">
            </div>
          </a>
          <span>买车卖车视频</span>
        </li>
        <li>
          <a href="http://web.lianlianche.com/index.html#/video2">
            <div>
              <img src="static/image/video2.png" alt="">
            </div>
          </a>
          <span>车达人获得马力</span>
        </li>
        <li>
          <a href="http://web.lianlianche.com/index.html#/video3">
            <div>
              <img src="static/image/video3.png" alt="">
            </div>
          </a>
          <span>邀请好友视频</span>
        </li>
        <div class="clearfix"></div>
      </ul>
    </div>
    <div class="line-5"></div>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="我要买车，如何操作？" name="1">
        <div><span>【1】</span>打开联联车App，选择二手车、新车、买车。</div>
        <div class="img"><img src="static/image/Course-img7.png" alt=""></div>
        <div><span>【2】</span>进入买车列表，选择您想要购买的车。</div>
        <div class="img"><img src="static/image/Course-img8.png" alt=""></div>
        <div><span>【3】</span>选择获得优惠。</div>
        <div class="img"><img src="static/image/Course-img9.png" alt=""></div>
        <div><span>【4】</span>输入手机号进行预约。</div>
        <div class="img"><img src="static/image/Course-img10.png" alt=""></div>
        <div><span>【5】</span>预约成功，销售人员会电话联系您，进行线下体验店看车试驾。</div>
        <div class="img"><img src="static/image/Course-img1.png" alt=""></div>
      </el-collapse-item>
      <el-collapse-item title="我要卖车，如何操作？" name="2">
        <div><span>【1】</span>打开联联车App，选择卖车。</div>
        <div class="img"><img src="static/image/Course-img11.png" alt=""></div>
        <div><span>【2】</span>进入卖车页面点击预约卖车。</div>
        <div class="img"><img src="static/image/Course-img12.png" alt=""></div>
        <div>【3】进入车辆信息页面，填写车辆相关信息，点击确认提交。专业顾问会电话联系您。</div>
        <div class="img"><img src="static/image/Course-img2.png" alt=""></div>
      </el-collapse-item>
      <el-collapse-item title="什么是马力，如何赚马力？" name="3">
        <div>【1】马力是联联车推出的用户贡献值。可以根据多种方式产生马力。</div>
        <div class="img"><img src="static/image/Course-img3.png" alt=""></div>
        <div>【2】普通用户邀请注册自己可以产生10马力。</div>
        <div class="img"><img src="static/image/Course-img6.png" alt=""></div>
        <div>【3】获取更多马力，需开通车达人。</div>
        <div class="img"><img src="static/image/Course-img13.png" alt=""></div>
      </el-collapse-item>
      <el-collapse-item title="什么是车达人，车达人的权益有哪些？" name="4">
        <div>【1】什么是车达人？</div>
        <div class="img"><img src="static/image/Course-img14.png" alt=""></div>
        <div>【2】车达人有什么权益？</div>
        <div class="img"><img src="static/image/Course-img15.png" alt=""></div>
      </el-collapse-item>
      <el-collapse-item title="我要如何分享？具体有哪些？" name="5">
        <div>【1-1】进入车辆详情，点击右上角的分享。</div>
        <div class="img"><img src="static/image/Course-img16.png" alt=""></div>
        <div>【1-2】分享微信、复制链接、商品二维码（最佳选择）三个选项任选一个。</div>
        <div class="img"><img src="static/image/Course-img5.png" alt=""></div>
        <div>【2-1】进入个人中心，点击邀请好友。</div>
        <div class="img"><img src="static/image/Course-img17.png" alt=""></div>
        <div>【2-2】选择主题海报，点击分享主题海报。</div>
        <div class="img"><img src="static/image/Course-img18.png" alt=""></div>
      </el-collapse-item>
      <el-collapse-item title="什么情况下奖励无效?" name="6">
        <div>以下几种情况会系统报警并处罚奖励或封号</div>
        <div>【1】虚拟软件涮量</div>
        <div>【2】同一个ID多次点击或群发相互点击</div>
        <div>【3】时间密集并且频率高<br></div>
        <div>正常广告行为:</div>
        <div>【1】展示率100-1500</div>
        <div>【2】广告点击约10次</div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker
} from 'mint-ui';
import Vue from "vue";
Vue.component(Header.name,Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
export default {
  name: 'Novice',
  data () {
    return {
      activeName: ''
    }
  },
  loadMore() {
  this.loading = true;
  setTimeout(() => {
    let last = this.list[this.list.length - 1];
    for (let i = 1; i <= 10; i++) {
      this.list.push(last + i);
    }
    this.loading = false;
  }, 2500);
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a{
    color: #2c2c2c;
}
html{
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Novice.vue